import React from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import InputField from 'components/v2/input-field/input-field';

const localeKeyPrefix = 'shopify.settings.addressSettingsSection.form';

const AddressDetailField = props => {
  const { initialValue, ...other } = props;
  return (
    <InputField
      {...other}
      placeholder={`${I18n.t(`${localeKeyPrefix}.placeholder.addressDetail`)}`}
      fieldOptions={{
        initialValue,
      }}
    />
  );
};

AddressDetailField.propTypes = {
  id: PropTypes.string.isRequired,
  form: PropTypes.shape({}).isRequired,
  initialValue: PropTypes.string,
  disabled: PropTypes.bool,
};

AddressDetailField.defaultProps = {
  initialValue: '',
  disabled: false,
};

export default AddressDetailField;
